export default "__VITE_ASSET__d23bcb4d__"